// Shared reader for the site-wide catalogue JSON export
// (snippets/makc-search-catalogue.liquid, rendered from layout/theme.liquid)
// -- parsed once, here, rather than re-parsed independently in every
// consumer. Extracted once a third real consumer needed the exact same
// "parse [data-makc-search-catalogue], fall back to [] on anything
// missing/malformed" logic (assets/makc-cart-shell.js and assets/
// makc-time-picker.js, both added in the same pass that created this
// file) -- assets/makc-search-takeover.js's own existing inline copy
// (the first, already-shipped instance) is deliberately left as-is,
// not retrofitted to use this: that's an unrelated, already-working
// file outside this pass's actual scope, not something to refactor
// just because a shared version now exists elsewhere.
window.makcCatalogue = (function () {
  var catalogue = [];
  var catalogueEl = document.querySelector('[data-makc-search-catalogue]');
  if (catalogueEl) {
    try {
      catalogue = JSON.parse(catalogueEl.textContent) || [];
    } catch (e) {
      catalogue = [];
    }
  }

  // Made-to-order can't be determined from a cart line item alone --
  // confirmed by inspecting this store's own real /cart.js response
  // directly: line items expose id/properties/quantity/variant_id/
  // price/sku/product_type/handle/product_title/etc, but no tags and
  // no metafields at all. The catalogue's own menu_category field
  // (already exported for every product, "Made to Order" being one of
  // the four known category values) is the only already-available,
  // generic signal -- confirmed against this store's real data: Masa
  // (the one product already used elsewhere as a made-to-order example)
  // has menu_category "Made to Order" exactly, alongside 21 other real
  // products sharing it. Cross-referencing a cart line's product_id
  // against this avoids hardcoding a product name/title list (the
  // narrower pattern this replaces -- see assets/makc-time-picker.js's
  // own comment on what used to be here) and needs no changes to the
  // product sheet's add-to-cart flow to expose anything new.
  function isMadeToOrder(productId) {
    var product = catalogue.filter(function (entry) {
      return entry.id === productId;
    })[0];
    return !!(product && product.menu_category === 'Made to Order');
  }

  // Real MTO pickup-date math (assets/makc-time-picker.js) needs the
  // three per-product metafields CLAUDE.md's own data model names --
  // order_cutoff_time, lead_days, earliest_pickup_time -- now exported
  // alongside every other catalogue field by snippets/
  // makc-search-catalogue.liquid. Returns null (not a partially-filled
  // object) whenever any of the three is missing, since a non-MTO
  // product or an MTO product whose metafields haven't been filled in
  // yet in Admin can't produce a meaningful constraint from a subset --
  // callers branch on this null the same way they'd branch on
  // isMadeToOrder() being false.
  function getMtoConstraints(productId) {
    var product = catalogue.filter(function (entry) {
      return entry.id === productId;
    })[0];
    if (!product) {
      return null;
    }
    if (
      product.order_cutoff_time == null ||
      product.lead_days == null ||
      product.earliest_pickup_time == null
    ) {
      return null;
    }
    return {
      orderCutoffTime: product.order_cutoff_time,
      leadDays: product.lead_days,
      earliestPickupTime: product.earliest_pickup_time
    };
  }

  // Whether the product carries any modifier group (the custom.
  // modifier_groups metaobject list, the same source the product sheet
  // renders its option groups from) -- exported as one boolean per
  // product by snippets/makc-search-catalogue.liquid rather than the
  // group definitions themselves, since the only consumer so far
  // (the cart shell's edit-item work) needs a yes/no, and a cart line
  // item alone can't answer it: line item properties are absent for a
  // product whose optional groups were all left unselected. Variant
  // options are a separate question, answered from the line itself
  // (product_has_only_default_variant / options_with_values). Unknown
  // product id reads as false.
  function hasModifierGroups(productId) {
    var product = catalogue.filter(function (entry) {
      return entry.id === productId;
    })[0];
    return !!(product && product.has_modifier_groups === true);
  }

  return {
    getAll: function () {
      return catalogue;
    },
    isMadeToOrder: isMadeToOrder,
    getMtoConstraints: getMtoConstraints,
    hasModifierGroups: hasModifierGroups
  };
})();
